module.exports = __webpack_public_path__ + "img/glcdw-part-fa-pic1.5707d3f8.png";